<!-- eslint-disable -->
<!--
* ReferencesController
-->
<template>
    <div class="component-index-controller uk-container">
        <h2 class="uk-h1 uk-margin-top">
            In The News
        </h2>
        <div class="uk-section-small uk-section-muted uk-padding">
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/independent.jpg">
                </div>
                <p span class="uk-text-bold">
                    Sex workers harassed, assaulted and illegally targeted for deportations amid culture of xenophobia after Brexit, campaigners say
                </p>
                <p>
                    <a href="https://www.independent.co.uk/news/uk/home-news/sex-work-brexit-arrests-deportation-uk-eu-migrant-workers-english-collective-prostitutes-a8850816.html" target="_blank">
                        https://www.independent.co.uk/news/uk/home-news/sex-work-brexit-arrests-deportation-uk-eu-migrant-workers-english-collective-prostitutes-a8850816.html
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 06 Apr 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/bbc.jpg">
                </div>
                <p span class="uk-text-bold">
                    Life as a Yarl's Wood immigration detainee 'like hell'
                </p>
                <p>
                    <a href="https://www.bbc.co.uk/news/uk-england-beds-bucks-herts-47802425" target="_blank">
                        https://www.bbc.co.uk/news/uk-england-beds-bucks-herts-47802425
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 05 Apr 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/guardian.png">
                </div>
                <p span class="uk-text-bold">
                    Judge rules £1/hr wages for immigration detainees are lawful
                </p>
                <p>
                    <a href="https://www.theguardian.com/uk-news/2019/mar/27/judge-rules-1hr-wages-lawful-for-immigration-centre-detainees" target="_blank">
                        https://www.theguardian.com/uk-news/2019/mar/27/judge-rules-1hr-wages-lawful-for-immigration-centre-detainees
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 27 Mar 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/guardian.png">
                </div>
                <p span class="uk-text-bold">
                    Catalogue of failings led to death of 'gentle' man at detention centre
                </p>
                <p>
                    <a href="https://www.theguardian.com/uk-news/2019/mar/25/catalogue-of-failings-led-to-death-of-gentle-man-at-detention-centre" target="_blank">
                        https://www.theguardian.com/uk-news/2019/mar/25/catalogue-of-failings-led-to-death-of-gentle-man-at-detention-centre
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 25 Mar 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/bbc.jpg">
                </div>
                <p span class="uk-text-bold">
                    Home Office 'utterly failing' over immigration detention centres
                </p>
                <p>
                    <a href="https://www.bbc.co.uk/news/uk-47645883" target="_blank">
                        https://www.bbc.co.uk/news/uk-47645883
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 21 Mar 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/independent.jpg">
                </div>
                <p span class="uk-text-bold">
                    More than 100 women in Yarl's Wood detention centre go on hunger strike over 'inhumane' conditions
                </p>
                <p>
                    <a href="https://www.independent.co.uk/news/uk/home-news/yarls-wood-women-immigration-detention-centre-hunger-strike-home-office-a8223886.html" target="_blank">
                        https://www.independent.co.uk/news/uk/home-news/yarls-wood-women-immigration-detention-centre-hunger-strike-home-office-a8223886.html
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 22 Feb 2019
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/guardian.png">
                </div>
                <p span class="uk-text-bold">
                    Worse than prison: life inside Britain's 10 deportation centres
                </p>
                <p>
                    <a href="https://www.theguardian.com/uk-news/2018/oct/11/life-in-a-uk-immigration-removal-centre-worse-than-prison-as-criminal-sentence" target="_blank">
                        https://www.theguardian.com/uk-news/2018/oct/11/life-in-a-uk-immigration-removal-centre-worse-than-prison-as-criminal-sentence
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 11 Oct 2018
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/bbc.jpg">
                </div>
                <p span class="uk-text-bold">
                    Mum and daughter home after Yarl's Wood detention
                </p>
                <p>
                    <a href="https://www.bbc.co.uk/news/uk-england-stoke-staffordshire-44051960" target="_blank">
                        https://www.bbc.co.uk/news/uk-england-stoke-staffordshire-44051960
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 09 May 2018
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/independent.jpg">
                </div>
                <p span class="uk-text-bold">
                    Home Office holding torture victims with 'high level' mental health needs in detention, finds watchdog
                </p>
                <p>
                    <a href="https://www.independent.co.uk/news/uk/home-news/home-office-torture-victims-mental-health-prison-detention-immigration-a8253006.html" target="_blank">
                        https://www.independent.co.uk/news/uk/home-news/home-office-torture-victims-mental-health-prison-detention-immigration-a8253006.html
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 13 Mar 2018
                </p>
            </div>
            <div class="uk-card uk-card-default uk-card-body uk-margin uk-width-1-1 uk-card-small ref">
                <div class="uk-align-left">
                    <img class="uk-border-circle news-logo" src="../assets/images/bbc.jpg">
                </div>
                <p span class="uk-text-bold">
                    What I saw when
                    I went undercover:
                    The 21-year-old whistleblower
                    at the immigration removal centre
                </p>
                <p>
                    <a href="https://www.bbc.co.uk/news/resources/idt-sh/g4s_brook_house_immigration_removal_centre_undercover" target="_blank">
                        https://www.bbc.co.uk/news/resources/idt-sh/g4s_brook_house_immigration_removal_centre_undercover
                    </a>
                </p>
                <p class="uk-text-muted">
                    Date Published: 04 Sep 2017
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsController',
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
    @import './../assets/scss/variables';
    .ref {
        > * {
            margin-top: 0;
            margin-bottom: 0;
        }
    }
    .news-logo {
        width: 80px;
        height: 80px;
    }
</style>

